import React from 'react';
import { Radio, RadioGroup } from '@blueprintjs/core';

class RadioButton extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      value: this.props.selectedValue
    }
  }

  onChange(e) {
    this.setState({
      value: e.target.value
    });

    this.props.onChange(e);
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.selectedValue != nextProps.selectedValue) {
      this.setState({value: nextProps.selectedValue});
    }
  }

  render() {
    return (
      <RadioGroup className="radio-gender" onChange={this.onChange.bind(this)} selectedValue={this.state.value} disabled={this.props.disable}>
        {this.props.options.map((item,i) => {
          return (
            <Radio key={i} label={item[this.props.valueName]}
            value={item[this.props.keyName]}
            className={this.props.itemClass} />);
        })}
      </RadioGroup>
    )
  }
}

RadioButton.defaultProps = {
  options: [],
  onChange: function () {
    console.log('Need to assign onChange method');
  },
  selectedValue: '',
  keyName: 'key',
  valueName: 'value',
  itemClass: 'pt-large txt-bold radio-header'
}

export default RadioButton;



// WEBPACK FOOTER //
// ./src/components/tt-forms/common/RadioButton.jsx